import { render } from "./Step2.vue?vue&type=template&id=fdfb41c6&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"

import "./Step2.vue?vue&type=style&index=0&id=fdfb41c6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfb41c6"]])

export default __exports__